<template>
    <div>
        <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Import Product Database Data</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text dense>
                <v-layout row>
                    <v-flex xs12 body-2 pt-1>
                        <v-select
                        v-model="itemClassSelected"
                        :items="itemClasses"
                        item-text="code"
                        item-value="code"
                        box
                        label="Class To Import"
                        ></v-select>
 
                    </v-flex>
                    <v-flex xs12 text-xs-center pt-1>
                        <v-btn @click="onPopulateInitData" large color="primary">Import Data</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 body-2 pt-1>Result:</v-flex>

                </v-layout>
                <v-layout row>
                    <v-flex xs12 text-xs-left pt-1 >
                        <table style="">
                            <thead>
                                <tr>
                                    <th>Row#</th>
                                    <th>ITEM CLASS</th>
                                    <th>ITEM NUMBER</th>
                                    <th>ITEM DESCRIPTION</th>
                                    <th>ITEM SHORT NAME</th>
                                    <th>BROCHURE</th>
                                    <th>PRICE</th>
                                    <th>MEMO</th>
                                    <th>IFU</th>
                                    <th>SDS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in items" :key="item.ITEMNUMBER">
                                    <td>{{idx + 2}}</td>
                                    <td>{{item.ITEMCLASS}}</td>
                                    <td>{{item.ITEMNUMBER}}</td>
                                    <td>{{item.ITEMDESCRIPTION}}</td>
                                    <td>{{item.ITEMSHORTNAME}}</td>
                                    <td>
                                        <table>
                                            <!-- <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th>PAGE #</th>
                                                    <th>LINK NAME</th>
                                                    <th>LINK</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.BrochureList" :key="idx">
                                                    <td>{{doc.Name}}</td>
                                                    <td>{{doc.AtPage}}</td>
                                                    <td>{{doc.urlName}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'">{{reduceUrl(doc.url)}}</a></td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <!-- <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th>PAGE #</th>
                                                    <th>LINK NAME</th>
                                                    <th>LINK</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.PriceList" :key="idx">
                                                    <td>{{doc.Name}}</td>
                                                    <td>{{doc.AtPage}}</td>
                                                    <td>{{doc.urlName}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'">{{reduceUrl(doc.url)}}</a></td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <!-- <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th>PAGE #</th>
                                                    <th>LINK NAME</th>
                                                    <th>LINK</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.MemoList" :key="idx">
                                                    <td>{{doc.Name}}</td>
                                                    <td>{{doc.AtPage}}</td>
                                                    <td>{{doc.urlName}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'">{{reduceUrl(doc.url)}}</a></td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <!-- <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th>PAGE #</th>
                                                    <th>LINK NAME</th>
                                                    <th>LINK</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.IfuList" :key="idx">
                                                    <td>{{doc.Name}}</td>
                                                    <td>{{doc.AtPage}}</td>
                                                    <td>{{doc.urlName}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'">{{reduceUrl(doc.url)}}</a></td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <!-- <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th>PAGE #</th>
                                                    <th>LINK NAME</th>
                                                    <th>LINK</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.SdsList" :key="idx">
                                                    <td>{{doc.Name}}</td>
                                                    <td>{{doc.AtPage}}</td>
                                                    <td>{{doc.urlName}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'">{{reduceUrl(doc.url)}}</a></td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data() {
        return {
            itemClassSelected: "All",
            itemClasses: [],
            items: []
        }
    },
    computed: {
    },
    methods: {
        ...mapActions('adminUser', [
            'populateInitData'
        ]),
        async onPopulateInitData() {
            // if(!confirm('are you sure to populate data? it just need when first time init data'))
            //     return

            this.items = await this.populateInitData(this.itemClassSelected)
        },
        ...mapActions('adminItemClass', [
            'getItemClasses',
            'showHideItemClassInWebQuote',
        ]),
        async loadClasses () {
            const result = await this.getItemClasses()
            if (typeof result === 'string') {
                alert(result)
            } else {
                this.itemClasses = [{code: 'All'}, ...result]
            }
        },
        reduceUrl(url){
            return url?url.trim().substr(url.length - 30):"FIX!"
        }
    },

    async created() {
        await this.loadClasses();
    },
}
</script>
<style scoped>
    table {
    border-collapse: collapse;
    }

    table, th, td {
    border: 1px solid black;
    }
</style>